import React, { useEffect, useState } from "react";
import CommonContainer from "../../Components/Landing/CommonContainer";
import { Box, Button, Grid, Typography, useTheme } from "@mui/material";
import CommonTextField from "../../Components/Common/CommonTextField";
import { Regex } from "../../Utils/regex";
// Note: Contact form API action - needs to be implemented in Redux
import { useDispatch } from "react-redux";
import { Bounce, toast } from "react-toastify";
import ErrorHandler from "../../Utils/handler";
import { showLoader } from "../../Redux/Slices/loaderSlice";

const ContactUs = () => {
  const theme = useTheme();
  const dispatch = useDispatch()
  const [data, setData] = useState({});
  const [errors, setErrors] = useState({});

  const validation = () => {
    let isValid = true;
    let error = {}

    if (!data?.name) {
      isValid = false
      error["name"] = "Please enter your name"
    }
    if (!data?.mobile) {
      isValid = false
      error["mobile"] = "Please enter your mobile no"
    }
    if (data?.mobile && !Regex.mobileNumberRegex.test(data?.mobile)) {
      isValid = false
      error["isValidMobile"] = "Please enter your valid mobile no"
    }
    if (!data?.message) {
      isValid = false
      error["message"] = "Please enter your message"
    }
    setErrors(error);
    return isValid
  }

  const handleSubmit = async () => {
    if (validation()) {
      dispatch(showLoader(true));
      const body = {
        fullName: data?.name,
        mobileNo: data?.mobile,
        message: data?.message
      }
      try {
        // TODO: Implement contact form submission API
        // For now, just show success message
        toast.success("Thank you for contacting us! We will get back to you soon.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
          transition: Bounce,
        })
        setData({})
        dispatch(showLoader(false));
      } catch (err) {
        console.error('Error:', err);
        dispatch(showLoader(false));
      }
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <CommonContainer>
        <Grid container spacing={2}>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <img
              src="/images/Frame-1321317330.png"
              alt="logo"
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item lg={6} md={6} sm={12} xs={12}>
            <Typography
              color={"primary"}
              sx={{
                fontSize: { lg: "52px", md: "30px", sm: "26px", xs: "20px" },
                fontWeight: "900",
              }}
            >
              Get in Touch
            </Typography>
            <Typography
              sx={{
                fontSize: { lg: "20px", md: "16px", sm: "16px", xs: "12px" },
                color: "#4b4c4c",
              }}
            >
              {" "}
              Have questions or need support? Get in touch with the PPSK team -
              we’re here to help you grow faster and smarter.
            </Typography>
            <Box mt={{ lg: 3, md: 2, sm: 1, xs: 1 }}>
              <CommonTextField
                value={data?.name || ""}
                onChange={(e) => {
                  setData({
                    ...data,
                    name: e?.target?.value,
                  });
                }}
                text={"Name"}
                placeholder={"Enter your name"}
                valid
              />
              <Typography variant="caption" color={"error"}>{!data?.name ? errors?.name : ""}</Typography>
            </Box>
            <Box mt={{ lg: 3, md: 2, sm: 1, xs: 1 }}>
              <CommonTextField
                type="number"
                value={data?.mobile || ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d{0,10}$/.test(value)) {
                    setData({
                      ...data,
                      mobile: value,
                    });
                  }
                }}
                text="Mobile No"
                placeholder="Enter your mobile no"
                valid
              />
              <Typography variant="caption" color={"error"}>{!data?.mobile ? errors?.mobile : ""}</Typography>
              <Typography variant="caption" color={"error"}>{data?.mobile && !Regex.mobileNumberRegex.test(data?.mobile) ? errors?.isValidMobile : ""}</Typography>
            </Box>
            <Box mt={{ lg: 3, md: 2, sm: 1, xs: 1 }}>
              <CommonTextField
                value={data?.message || ""}
                onChange={(e) => {
                  setData({
                    ...data,
                    message: e?.target?.value,
                  });
                }}
                text={"Message"}
                placeholder={"Enter your message"}
                multiline
                rows={4}
                valid
              />
              <Typography variant="caption" color={"error"}>{!data?.message ? errors?.message : ""}</Typography>
            </Box>
            <Button
              sx={{
                mt: 2,
                width: "128px",
                padding: "6px 24px",
                position: "relative",
                overflow: "hidden",
                borderRadius: "10px",
                backgroundColor: theme.palette.primary.main,
                color: "white",
                fontSize: "16px",
                fontWeight: "500",
                textTransform: "none",
                zIndex: 1,
                "&:hover": {
                  backgroundColor: theme.palette.primary.main,
                },
                "&::before": {
                  content: '""',
                  position: "absolute",
                  width: 0,
                  height: 0,
                  top: "50%",
                  left: "50%",
                  backgroundColor: "#9e110c",
                  borderRadius: "50%",
                  transform: "translate(-50%, -50%)",
                  zIndex: -1,
                  transition: "all 500ms ease-in-out",
                },
                "&:hover::before": {
                  width: "300px",
                  height: "300px",
                },
              }}
              onClick={() => handleSubmit()}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
      </CommonContainer>
    </>
  );
};

export default ContactUs;
